import loadable from '@loadable/component';

export const TestPage = loadable(/* #__LOADABLE__ */ () => import('./TestPage'));
